import React from "react"
import colors from "src/theme/colors"
import { useHistory } from "react-router"

import styled from "styled-components"
import "./style.scss"
import { HelpInfo } from "src/components/help-center-section"
import { Text } from "./styled-compnent"
import moment from "moment"

export const GridContainer = styled.div<any>`
  display: flex;
  margin-bottom: 1px;
  width: ${props => (props.width ? props.width : "100%")};
  @media (max-width: 900px) {
    width: 100%;
  }
`

export const ArticleCard = styled.div<any>`
  display: flex;
  box-shadow: -1px 3px 6px #00000029;
  padding: 1.5rem 3rem;
  align-items: center;
  border-radius: 4px;
  background: #fff;
  width: 100%;
  cursor: pointer;
`

type Props = {
  width?: string
  color: string
  title: string
  description: string
  id: string
  updatedAt: string
}

const CollectionCard = (props: Props) => {
  const { description = "", title = "", id, updatedAt } = props

  const { width = "100%" } = props
  const history = useHistory()

  const gotoSingleArticle = (id: string, name: string, desc: string) => {
    history.push({
      pathname: `/help-center/collection/article/${id}`,
      state: {
        title: name,
        description: desc
      }
    })
  }

  return (
    <GridContainer width={width} onClick={() => gotoSingleArticle(id, title, description)}>
      <ArticleCard>
        <div>
          <Text fontSize={17} fontWeight={300} color={colors.primary}>
            {title}
          </Text>
          <Text fontSize={15} fontWeight={300} color={colors.darkGrey}>
            {description}
          </Text>
          <HelpInfo
            title="Written by Tolobi Team"
            subTitle={`Updated over ${moment.utc(Number(updatedAt)).fromNow()}`}
          />
        </div>
      </ArticleCard>
    </GridContainer>
  )
}

export default CollectionCard
